<div
    class="sidenav_container"
    [@onSideNavChange]="sideNavState ? 'open' : 'close'"
>
    <div fxLayout="column" fxLayoutGap="10px" class="container">
        <div class="btn-fixed">
            <div
                fxLayout="row"
                fxLayoutAlign="end center"
                [ngClass]="{
                    'btn-open': sideNavState,
                    'btn-close': !sideNavState
                }"
            >
                <button
                    mat-icon-button
                    (click)="onSinenavToggle()"
                    class="btn-open-menu"
                >
                    <app-mb-icon
                        *ngIf="sideNavState"
                        icon="select-left"
                        style="color: #acb0bc"
                    ></app-mb-icon>
                    <app-mb-icon
                        *ngIf="!sideNavState"
                        icon="select-right"
                        style="color: #acb0bc"
                    ></app-mb-icon>
                </button>
            </div>
            <mat-divider></mat-divider>
        </div>

        <div>
            <div>
                <mat-nav-list>
                    <a
                        mat-list-item
                        *ngFor="let page of pages"
                        [@selectedItemMenuState]="page.state"
                        class="nav-item"
                        style="color: #ffffff"
                        (click)="goTo(page.link)"
                    >
                        <div class="link-content">
                            <img
                                *ngIf="page.iconSrc"
                                [src]="page.iconSrc"
                                alt="icon name"
                            />
                            <mat-icon
                                *ngIf="!page.iconSrc && page.icon"
                                [fontIcon]="page.icon"
                                style="color: #fff"
                                size="sm"
                            ></mat-icon>
                            <span
                                [@animateText]="linkText ? 'show' : 'hide'"
                                class="page-title"
                            >
                                {{ page?.name }}
                            </span>
                        </div>
                    </a>
                </mat-nav-list>
            </div>
        </div>
        <span class="spacer"></span>
    </div>
</div>
